import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import CidesLogo from "@/components/CidesLogo";
import { EnvelopeSimple, MapPin, Buildings } from "@phosphor-icons/react";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/[0.08] bg-[#0d1421]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <CidesLogo height={44} />
          <p className="mt-6 text-slate-300 text-sm max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
          <p className="mt-6 text-[11px] uppercase tracking-[0.2em] text-slate-300">
            {t("contact.company")}
          </p>
        </div>

        <div>
          <div className="section-eyebrow mb-4">{t("footer.nav")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-slate-300 hover:text-white transition">{t("nav.home")}</Link></li>
            <li><Link to="/documents" className="text-slate-300 hover:text-white transition">{t("nav.documents")}</Link></li>
            <li><Link to="/telecom" className="text-slate-300 hover:text-white transition">{t("nav.telecom")}</Link></li>
            <li><Link to="/finance" className="text-slate-300 hover:text-white transition">{t("nav.finance")}</Link></li>
            <li><Link to="/contact" className="text-slate-300 hover:text-white transition">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="section-eyebrow mb-4">{t("footer.contact")}</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2">
              <EnvelopeSimple size={16} className="mt-0.5 text-[#0089C8]" />
              <a href="mailto:management@cidesinvest.io" className="hover:text-white">management@cidesinvest.io</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-[#0089C8]" />
              <span>23 Woodvale Avenue, Giffnock, Glasgow, UK, G46 6RG</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.08]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between text-[11px] uppercase tracking-[0.2em] text-slate-400 gap-2">
          <div>© {year} CIDES Invest &amp; Trade Ltd — {t("footer.rights")}</div>
          <div>cidesinvest.io</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
